import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landings',
  templateUrl: './landings.component.html',
  styleUrls: ['./landings.component.scss']
})
export class LandingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
